/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  CommentCreateRequest,
  CommentDTO,
  CommentReplyCreateRequest,
  CommentReplyDTO,
  CommentSummaryDTO,
  CreateCommentPathParameters,
  DeleteCommentPathParameters,
  GetAllCommentsForTouchpointParams,
  GetAllCommentsForTouchpointPathParameters,
  GetCommentRepliesParams,
  GetCommentRepliesPathParameters,
  GetCommentSummaryParams,
  GetCommentSummaryPathParameters,
  PagedModelCommentDTO,
  PagedModelCommentReplyDTO,
  ReplyToCommentPathParameters,
  UpdateCommentPathParameters,
  UpdateCommentVm,
} from "../schemas";

import { customInstance } from "../../config/mutator";

export const getTouchpointComment = () => {
  /**
 * Update a comment on a touchpoint version

Required authority: PERM_COMMENT_WRITE
 */
  const updateComment = (
    { clientId, campaignId, touchpointId, id }: UpdateCommentPathParameters,
    updateCommentVm: UpdateCommentVm,
  ) => {
    return customInstance<CommentDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/comments/${id}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateCommentVm,
    });
  };
  /**
 * Deletes a comment. PERM_COMMENT_WRITE

Required authority: PERM_COMMENT_WRITE
 */
  const deleteComment = ({
    clientId,
    campaignId,
    touchpointId,
    id,
  }: DeleteCommentPathParameters) => {
    return customInstance<void>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/comments/${id}`,
      method: "DELETE",
    });
  };
  /**
 * Get all comments on a touchpoint

Required authority: PERM_TOUCHPOINT_READ
 */
  const getAllCommentsForTouchpoint = (
    { clientId, campaignId, touchpointId }: GetAllCommentsForTouchpointPathParameters,
    params?: GetAllCommentsForTouchpointParams,
  ) => {
    return customInstance<PagedModelCommentDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/comments`,
      method: "GET",
      params,
    });
  };
  /**
 * Create a comment on a touchpoint version

Required authority: PERM_COMMENT_WRITE
 */
  const createComment = (
    { clientId, campaignId, touchpointId }: CreateCommentPathParameters,
    commentCreateRequest: CommentCreateRequest,
  ) => {
    return customInstance<CommentDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/comments`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: commentCreateRequest,
    });
  };
  /**
 * Get replies to a comment

Required authority: PERM_TOUCHPOINT_READ
 */
  const getCommentReplies = (
    { clientId, campaignId, touchpointId, id }: GetCommentRepliesPathParameters,
    params?: GetCommentRepliesParams,
  ) => {
    return customInstance<PagedModelCommentReplyDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/comments/${id}/replies`,
      method: "GET",
      params,
    });
  };
  /**
 * Reply to a comment

Required authority: PERM_COMMENT_WRITE
 */
  const replyToComment = (
    { clientId, campaignId, touchpointId, id }: ReplyToCommentPathParameters,
    commentReplyCreateRequest: CommentReplyCreateRequest,
  ) => {
    return customInstance<CommentReplyDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/comments/${id}/replies`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: commentReplyCreateRequest,
    });
  };
  /**
 * Get comment summary for a touchpoint version

Required authority: PERM_TOUCHPOINT_READ
 */
  const getCommentSummary = (
    { clientId, campaignId, touchpointId }: GetCommentSummaryPathParameters,
    params?: GetCommentSummaryParams,
  ) => {
    return customInstance<CommentSummaryDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/comments/summary`,
      method: "GET",
      params,
    });
  };
  return {
    updateComment,
    deleteComment,
    getAllCommentsForTouchpoint,
    createComment,
    getCommentReplies,
    replyToComment,
    getCommentSummary,
  };
};
export type UpdateCommentResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointComment>["updateComment"]>>
>;
export type DeleteCommentResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointComment>["deleteComment"]>>
>;
export type GetAllCommentsForTouchpointResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointComment>["getAllCommentsForTouchpoint"]>>
>;
export type CreateCommentResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointComment>["createComment"]>>
>;
export type GetCommentRepliesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointComment>["getCommentReplies"]>>
>;
export type ReplyToCommentResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointComment>["replyToComment"]>>
>;
export type GetCommentSummaryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointComment>["getCommentSummary"]>>
>;
